import type { ReservationPolicy } from '@wineryxplorer/shared';

const ALL: { value: ReservationPolicy; label: string }[] = [
  { value: 'required', label: 'Reservation' },
  { value: 'recommended', label: 'Recommended' },
  { value: 'drop-ins-welcome', label: 'Drop-ins' },
];

interface ReservationPolicyToggleProps {
  value: ReservationPolicy[] | undefined;
  onChange: (next: ReservationPolicy[] | undefined) => void;
}

export const ReservationPolicyToggle = ({ value, onChange }: ReservationPolicyToggleProps) => {
  const selected = value ?? [];

  const toggle = (policy: ReservationPolicy) => {
    const has = selected.includes(policy);
    const next = has ? selected.filter((p) => p !== policy) : [...selected, policy];
    onChange(next.length === 0 ? undefined : next);
  };

  // Phones: fill the row with segments that never break mid-label (the fixed
  // widths overflowed a 390px screen); on the narrowest screens a whole segment
  // wraps instead. sm+ keeps the compact inline pill.
  return (
    <div className="flex flex-wrap w-full sm:inline-flex sm:flex-nowrap sm:w-auto items-center gap-1 px-1 py-1 rounded-3xl sm:rounded-full bg-gray-50 border border-gray-200">
      {ALL.map((p) => {
        const isSelected = selected.includes(p.value);
        return (
          <button
            key={p.value}
            onClick={() => toggle(p.value)}
            aria-pressed={isSelected}
            className={`flex-auto sm:flex-none whitespace-nowrap text-xs font-sans tracking-wide sm:tracking-widest uppercase px-1.5 sm:px-3 py-1 min-h-[44px] sm:min-h-0 rounded-full transition-colors ${
              isSelected
                ? p.value === 'required'
                  ? 'bg-secondary-700 text-white'
                  : 'bg-primary-700 text-white'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {p.label}
          </button>
        );
      })}
    </div>
  );
};
